import axios, { type AxiosRequestConfig, type AxiosResponse } from "axios";

const normalizeBaseUrl = (value: string | undefined) =>
  (value || "").replace(/\/+$/, "");

export const getPimBaseUrl = () =>
  normalizeBaseUrl(
    process.env.VUE_APP_PIM_BASE_URL || process.env.VUE_APP_API_URL
  );

const getJwtToken = () => {
  const jwtToken = process.env.VUE_APP_PIM_JWT_TOKEN;

  if (!jwtToken) {
    throw new Error("Missing VUE_APP_PIM_JWT_TOKEN");
  }

  return jwtToken;
};

export const requestWithAuth = async <T>(
  config: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  const token = getJwtToken();

  return axios.request<T>({
    ...config,
    baseURL: getPimBaseUrl(),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(config.headers || {}),
    },
  });
};
